









































































































































































































































































































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Users from "@/store/modules/Users";
import ChoiceSubmitter from "@/views/ChoiceSubmitter/ChoiceSubmitter.vue";
import StorageImage from "@/components/common/StorageImage.vue";
import ViewpointCard from "@/components/common/ViewpointCard.vue";
import Scoring from "@/store/modules/Scoring";
import BucketingGroups from "@/components/buckets/BucketingGroups.vue";
import Viewpoints from "@/store/modules/Viewpoints";
import ChoiceFactorInput from "@/components/choice-input/ChoiceFactorInput.vue";
import Choices from "@/store/modules/Choices";
import { NotificationEventBus } from "@/EventBus";
import Colors from "@/utils/Colors";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import Sticky from 'vue-sticky-directive';
import FactorValueDisplay from "@/components/common/FactorValueDisplay.vue";
import ChoiceInputSubTree from "@/components/choice-input/ChoiceInputSubTree.vue";
import ScoringKeys from "@/store/modules/ScoringKeys";
import ScoreSliderKey from "@/components/scoring-input/ScoreSliderKey.vue";
import ScoringKeyEditorDialog from "@/components/scoring-key/ScoringKeyEditorDialog.vue";
import ScoringKeyButtonTrigger from "@/components/scoring-key/ScoringKeyButtonTrigger.vue";
import Modelling from "@/store/modules/Modelling";
import { Factor, FactorGroup } from "@/api/model/FactorResource";
import FactorScoringDefinitionButtonTrigger from "@/components/scoring-definition/FactorScoringDefinitionButtonTrigger.vue";
import ChoiceViewpointScorerMenu from '@/views/ChoiceViewpointsScorer/ChoiceViewpointScorerMenu.vue';
import ChoiceInputDialog from '@/components/choice-input/ChoiceInputDialog.vue';
import ChoiceListInputDialog from  "@/components/Lists/ChoiceListInputDialog.vue"
import ChoiceListSelection from  "@/components/Lists/ChoiceListSelection.vue"
import Decisions from "@/store/modules/Decisions";

const users = getModule(Users);
const scoringKeysModule = getModule(ScoringKeys);
const scoringModule = getModule(Scoring)
const viewpointsModule = getModule(Viewpoints);
const choicesModule = getModule(Choices)
const workspaceOptionsModule = getModule(WorkspaceOptions)
const modellingModule = getModule(Modelling)
const decisionsModule = getModule(Decisions)

@Component({
    components: {
        ButtonScoringDefinitionTrigger: FactorScoringDefinitionButtonTrigger,
        ButtonScoringKeyTrigger: ScoringKeyButtonTrigger,
        ScoringKeyEditorDialog,
        ChoiceSubTreeEditor: ChoiceInputSubTree,
        FactorValueDisplay,
        FactorValueInput: ChoiceFactorInput,
        BinSet: BucketingGroups,
        StorageImage,
        ChoiceSubmitter,
        ViewpointCard,
        ChoiceInputDialog,
        ChoiceViewpointScorerMenu,
        ChoiceListInputDialog,
        ChoiceListSelection,
        ScoringSliderSelect: ScoreSliderKey
    },
    directives: {
        Sticky,
    },
})

export default class FactorChoiceScoringViewpoint extends Vue {

    @Prop()
    viewpoint!: any;

    @Prop()
    selectedResource!: any;

    @Prop()
    columnWidth!: number;

    @Prop()
    hoverId!: any;

    item!: any;

    private choiceDialog: boolean = false;
    private choiceName: string = '';
    private selectedChoice: any = {id:'',name:''};
    private choiceFactorInputDialog: boolean = false;
    private choiceFactorInputForm: any = null;
    private colors = Colors.COLORS
    private menuShow: boolean = false;
    private binChoices = [];

    get viewpointIndex() {
        return (viewpointsModule.selectedViewpoints || [])
            .indexOf(this.viewpoint)
    }

    get factorResource() {
        let factorResourceId = this.selectedResource.id;
        return modellingModule.publishedModelFactorResources[factorResourceId]
    }

    get isLoaded() {
        return true;
    }

    get currentUser() {
        return users.currentUserProfile;
    }

    get isOwner() {
        return this.currentUser && this.viewpoint.ownerUserId === this.currentUser.userId
    }

    get viewpointScoringKey() {
        if (scoringKeysModule.viewpointScoringKeyDefinitions[this.viewpoint.viewpointId]['M']) {
            //@ts-ignore
            return scoringKeysModule.viewpointScoringKeyDefinitions[this.viewpoint.viewpointId]['M'].scoringKeys || []
        }
        return []
    }

    get viewpointChoiceFactors() {
        return viewpointsModule.viewpointChoiceFactorResource[this.viewpoint.viewpointId] || {}
    }

    get isReadonly(): boolean {
        return !!(!this.currentUser
            || this.viewpoint.ownerUserId != this.currentUser.userId
            || this.factorResource.type != 'FACTOR'
            || ((this.factorResource as Factor).scoringDefinition && (this.factorResource as Factor).scoringDefinition.type != 'MANUAL'))
            || this.factorResource.numWeightingDots === 0;
    }

    get viewpointScores() {
        return scoringModule.viewpointScores[this.viewpoint.viewpointId]
    }

    get scoredChoices() {
        if (this.viewpointScores) {
            return this.viewpointScores.choiceScores
        }
    }

    get scoringKeys() {
        if (scoringKeysModule.viewpointScoringKeyDefinitions[this.viewpoint.viewpointId][this.factorResource.id]) {
            //@ts-ignore
            return scoringKeysModule.viewpointScoringKeyDefinitions[this.viewpoint.viewpointId][this.factorResource.id].scoringKeys
        }
        return []
    }

    get listDefinition() {
        return {
            id: this.viewpoint.viewpointId,
            name: this.viewpoint.name,
            label: this.viewpoint.name,
            readonly: this.isReadonly,
            visible: true,
        };
    }

    get scoreEdit() {
        return workspaceOptionsModule.editScores;
    }

    get scoreSlider() {
        return true;
    }

    get displayScoreBar() {
        return workspaceOptionsModule.scoreBarVisibility;
    }

    get scoringSliderLength() {
        if (this.columnWidth < 250 ) {
            return this.columnWidth - 50;
        }
        else {
            return 200;
        }
    }

    private factorLoadDialogData(item: any) {
        if (!this.factorResource || !this.factorResource.dataField) return;
        if (!this.isReadonly) {
            let form: any = {
                choiceId: item.id,
            }
            form[this.factorResource.dataField] = item.value
            this.choiceFactorInputForm = form;
            this.choiceFactorInputDialog = true;
        }
    }

    private choiceLoadDialogData(item: any) {
        this.selectedChoice = choicesModule.choices[item.id];
        this.choiceName = item.name;
        this.choiceDialog = !this.choiceDialog;
    }

    private onAdd(event: any) {
        this.rescoreBinItems(event.listId, event.binId, event.added.element, event.added.newIndex);
    }

    private onRemove(event: any) {

    }

    private onMove(event: any) {
        this.rescoreBinItems(event.listId, event.binId, event.moved.element, event.moved.newIndex)
    }

    private updateItemScore(newScore: any, event: any) {
        this.rescoreSliderBinItem(event.listId, event.id, newScore)
    }

    @Emit('new-scores')
    rescoreSliderBinItem(viewpointId: string, choiceId: string, newScore: number) {
        return {
            viewpointId: this.viewpoint.viewpointId,
            id: this.factorResource.id,
            choiceId: choiceId,
            newScore: newScore,
            draft: this.isOwner,
        } as UpdateScoreRequest;
    }

    @Emit('new-scores')
    rescoreBinItems(viewpointId: string, scoringKeyBin: string, changedElement: any, newIndex: number) {
        let binItems = this.factorChoiceItems
            .filter((cf: any) => cf.binId === scoringKeyBin)
            .filter((cf: any) => cf.id !== changedElement.id)
            .sort((a: any, b: any) => b.score - a.score);

        let changedChoiceFactor: any = this.factorChoiceItems.find((cf: any) => cf.id === changedElement.id);

        let bin = this.scoringKeyBins.find((sk: any) => sk.id === scoringKeyBin);
        if (bin && bin.upperLimitInclusive >= -1) {
            let range = bin.upperLimitInclusive - (bin.lowerLimitExclusive || 0);
            let choiceId;
            let newScore;
            if (binItems.length === 0) {
                changedChoiceFactor.score = bin.upperLimitInclusive - (range / 2);
                choiceId = changedElement.id;
                newScore = changedElement.score;
            } else {
                let topScore;
                let bottomScore;
                if (newIndex === 0) {
                    let bottomItem: any = binItems[0];
                    topScore = bin.upperLimitInclusive;
                    bottomScore = bottomItem.score;
                } else if (newIndex === binItems.length) {
                    let topItem: any = binItems[binItems.length - 1];
                    topScore = topItem.score;
                    bottomScore = (bin.lowerLimitExclusive || 0);
                } else {
                    let topItem: any = binItems[newIndex - 1];
                    let bottomItem: any = binItems[newIndex];
                    topScore = topItem.score;
                    bottomScore = bottomItem.score;
                }
                changedChoiceFactor.score = (topScore - bottomScore) / 2 + bottomScore;
                choiceId = changedElement.id;
                newScore = changedElement.score;
            }
            return {
                viewpointId: this.viewpoint.viewpointId,
                id: this.factorResource.id,
                choiceId: choiceId,
                newScore: newScore,
                draft: this.isOwner,
            } as UpdateScoreRequest;
        }
    }

    get scoringKeyBins() {
        let bins: any[] = [];
        if (this.scoringKeys && this.scoringKeys.length > 0) {
            for (let index = 0; index < this.scoringKeys.length; index++) {
                let scoringKey = this.scoringKeys[index];
                bins.push({
                    id: index,
                    upperLimitInclusive: scoringKey.upperLimit,
                    lowerLimitExclusive: scoringKey.lowerLimitExclusive,
                    name: scoringKey.name,
                    description: scoringKey.description
                })
            }

            let lowers: number[] = bins.map((b: any) => b.lowerLimitExclusive);
            let uppers: number[] = bins.map((b: any) => b.upperLimitInclusive);
            lowers.push(1.0);
            let max = Math.max(...uppers);
            if (max !== 1.0) {
                bins.splice(bins.length, 0, {
                    id: 'Other',
                    name: "Other",
                    lowerLimitExclusive: -100,
                    upperLimitInclusive: -101
                });
            }
        } else {
            let bin = {
                id: 'Other',
                name: "Other",
                upperLimitInclusive: 1
            };
            bins.splice(bins.length - 1, 0, bin);
        }
        return bins.sort((a: any, b: any) => b.upperLimitInclusive - a.upperLimitInclusive);
    }

    get choiceIds(): string [] {
        return choicesModule.choiceIds;
    }

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    get choices() {
        return choicesModule.choices;
    }
    get factorChoiceItems() {
        let items: any[] = [];
        for (let choiceId of this.choiceIds) {
            if (this.scoredChoices == null || this.scoredChoices[choiceId] == null) continue;
            let choiceData = this.choices[choiceId]

            let choiceFactorResourceData: any = {
                id: choiceData.id,
                image: choiceData.image,
                name: choiceData.name,
                value: this.factorResource.dataField ? choiceData[this.factorResource.dataField] : null,
                valueTypeDefinition: this.factorResource.type === 'FACTOR' ? (this.factorResource as Factor).valueTypeDefinition :
                    (this.factorResource as FactorGroup).groupTypeDefinition ? (this.factorResource as FactorGroup).groupTypeDefinition.valueTypeDefinition : null
            }

            let choiceScores = this.scoredChoices[choiceId].choiceFactorScores[this.factorResource.id]
            if (this.viewpointChoiceFactors[choiceId] && this.viewpointChoiceFactors[choiceId][this.factorResource.id]
                && this.viewpointChoiceFactors[choiceId][this.factorResource.id].score) {
                choiceFactorResourceData.score = this.viewpointChoiceFactors[choiceId][this.factorResource.id].score
            } else {
                // get viewpoint choice scores
                choiceFactorResourceData.score = choiceScores.score;
            }

            let scoringBin: any = this.getScoringBin(choiceFactorResourceData);
            if (scoringBin) {
                choiceFactorResourceData.binId = scoringBin.id;
            } else {
                choiceFactorResourceData.binId = 'other';
            }

            choiceFactorResourceData.listId = this.listDefinition.id;
            items.push(choiceFactorResourceData)
        }
        return items.sort((a, b) => b.score - a.score);
    }

    private getScoringBin(item: any) {
        let bin = this.scoringKeyBins.find(b => (item.score > b.lowerLimitExclusive || b.upperLimitInclusive === 0 || b.lowerLimitExclusive == null)
            && item.score <= b.upperLimitInclusive);

        if (!bin) {
            bin = this.scoringKeyBins.find(b => b.id === 'Other');
        }
        return bin;
    }

    private saveChoiceFactorValue() {
        this.choiceFactorInputDialog = false;
        let choice = Object.assign({}, choicesModule.choices[this.choiceFactorInputForm.choiceId]);
        if (this.factorResource.dataField) {
            choice[this.factorResource.dataField] = this.choiceFactorInputForm[this.factorResource.dataField];
        }
        NotificationEventBus.emitProcessingMessage();
        choicesModule.updateChoice({choice: choice, refreshScoring: true})
            .then(() => NotificationEventBus.emitSuccessMessage())
            .catch(err => NotificationEventBus.emitFailedMessage(err))
    }

    private onChangeHover(val){
        this.$emit('update:hoverId', val)
    }

    private indexOfChoice(id: string) {
        return choicesModule.choicesList.findIndex((choice: any) => id === choice.id)
    }

    private doesBinContainChoices(item: any) {
        for(let bin of this.factorChoiceItems) {
            if(bin.binId === item.id) {
                return true;
            }
        }
        return false;
    }

    private addChoicesToList(item) {
        let items = this.factorChoiceItems.filter((choice) => choice.binId === item.id).map((choice) => {return choice.id})
        this.binChoices = choicesModule.choicesList.filter((choice) => items.includes(choice.id));
    }

    private async addToLists(payload: string[]) {
        await decisionsModule.addChoicesToSelectLists({choices: this.binChoices, listIds: payload});
        this.binChoices = [];
    }

}

export interface UpdateScoreRequest {
    viewpointId: string,
    id: string
    choiceId: string,
    newScore: number,
    draft: boolean,
}

